"use strict";

exports.__esModule = true;
exports.StyledSegmentHeader = void 0;

var tslib_1 = require("tslib");

var Grid_1 = tslib_1.__importStar(require("@sportnet/ui/lib/Grid"));

var Icon_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Icon"));

var Label_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Label/Label"));

var Segment_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Segment"));

var Header_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Segment/Header"));

var polished_1 = require("polished");

var React = tslib_1.__importStar(require("react"));

var sportnet_utilities_1 = require("sportnet-utilities");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var Match_1 = tslib_1.__importDefault(require("../MatchOverview/Match"));

var TimeLine_1 = tslib_1.__importStar(require("./TimeLine"));

var FormGroup = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin: ", " 0;\n"], ["\n  margin: ", " 0;\n"])), polished_1.em(10));
var Text = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n"], ["\n  font-size: ", ";\n  color: ", ";\n"])), polished_1.em(13), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});
var NotFound = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  div {\n    color: ", ";\n    padding: ", " 0;\n    font-weight: lighter;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  div {\n    color: ", ";\n    padding: ", " 0;\n    font-weight: lighter;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.inactiveColor;
}, polished_1.em(10));
var NominationItems = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  & > div {\n    margin-left: -", ";\n  }\n"], ["\n  & > div {\n    margin-left: -", ";\n  }\n"])), polished_1.em(5));
var NominationHeader = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  & > img {\n    height: ", ";\n    margin-right: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  & > img {\n    height: ", ";\n    margin-right: ", ";\n  }\n"])), polished_1.em(30), polished_1.em(15));
var ListRow = styled_components_1["default"].div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  color: ", ";\n  font-size: ", ";\n  padding: ", " 0;\n  border-bottom: ", " solid ", ";\n  justify-content: space-between;\n  ", "\n"], ["\n  display: flex;\n  color: ", ";\n  font-size: ", ";\n  padding: ", " 0;\n  border-bottom: ", " solid ", ";\n  justify-content: space-between;\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
}, polished_1.em(13), polished_1.em(10), polished_1.em(1), function (_a) {
  var theme = _a.theme;
  return theme.separatorColor;
}, function (_a) {
  var lastIndex = _a.lastIndex;

  if (lastIndex) {
    return styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n        border-width: 0;\n      "], ["\n        border-width: 0;\n      "])));
  }

  return styled_components_1.css(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject([""], [""])));
});
var ListCol = styled_components_1["default"].div(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: ", ";\n"], ["\n  display: flex;\n  flex-wrap: ", ";\n"])), function (_a) {
  var flexWrap = _a.flexWrap;
  return !!flexWrap ? 'wrap' : 'no-wrap';
});
var EventIconWrapper = styled_components_1["default"].div(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n  padding: 0 ", ";\n"], ["\n  padding: 0 ", ";\n"])), polished_1.em(3));
exports.StyledSegmentHeader = styled_components_1["default"].div(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["\n  h3 {\n    font-weight: lighter;\n    font-size: ", ";\n    color: ", ";\n    padding: 0;\n    margin: 0;\n  }\n  h4 {\n    font-weight: lighter;\n    font-size: ", ";\n    color: ", ";\n    padding: 0;\n    margin: 0;\n  }\n"], ["\n  h3 {\n    font-weight: lighter;\n    font-size: ", ";\n    color: ", ";\n    padding: 0;\n    margin: 0;\n  }\n  h4 {\n    font-weight: lighter;\n    font-size: ", ";\n    color: ", ";\n    padding: 0;\n    margin: 0;\n  }\n"])), polished_1.em(22), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
}, polished_1.em(18), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});

var WidgetMatchDetail = function (_a) {
  var data = _a.data,
      theme = _a.theme,
      renderEmpty = _a.renderEmpty;

  var _b = React.useState(null),
      protocol = _b[0],
      setProtocol = _b[1];

  var _c = React.useState({}),
      timer = _c[0],
      setTimer = _c[1];

  if (!data.matchId && renderEmpty) {
    return React.createElement(React.Fragment, null, renderEmpty('matchDetail'));
  }

  if (data.data) {
    var _d = data.data,
        match_1 = _d.match,
        sportSectorPhases = _d.sportSectorPhases,
        sportEvents = _d.sportSectorEvents,
        sportCrew_1 = _d.sportSectorCrew,
        sportSectorDelegates_1 = _d.sportSectorDelegates;
    var sportSectorsPhases = sportSectorPhases.find(function (i) {
      return i._id === match_1.rules.sport_sector;
    });
    var sportSectorEvents_1 = sportEvents.find(function (i) {
      return i._id === match_1.rules.sport_sector;
    });

    var renderAthletesList_1 = function (appSpace, athletes) {
      return athletes.map(function (athlete, idx) {
        var athleteEvents = [];

        if (match_1.protocol) {
          var events = (match_1.protocol || {
            events: []
          }).events.filter(function (event) {
            return event.eventTime;
          }).map(function (event) {
            var timeParts = event.eventTime.split(':');
            var seconds = Number(timeParts[0]) * 60 + Number(timeParts[1]);
            return tslib_1.__assign(tslib_1.__assign({}, event), {
              eventTime: seconds
            });
          }).filter(function (i) {
            return i.type !== 'goal_shootout';
          });
          athleteEvents = events.filter(function (event) {
            return !!event.player && !!athlete.sportnetUser && event.player._id === athlete.sportnetUser._id;
          });
        }

        return React.createElement(ListRow, {
          key: athlete.sportnetUser._id,
          lastIndex: athletes.length === idx + 1
        }, React.createElement(ListCol, null, React.createElement("div", {
          style: {
            display: 'flex'
          }
        }, !!athlete.additionalData && !!athlete.additionalData.nr && React.createElement("div", {
          style: {
            width: polished_1.em(40)
          }
        }, athlete.additionalData.nr), React.createElement("b", null, athlete.sportnetUser.name))), React.createElement(ListCol, {
          flexWrap: true
        }, athleteEvents.map(function (event, eventIdx) {
          var eventDetail = (sportSectorEvents_1 || {
            items: []
          }).items.find(function (i) {
            return i._id === event.type;
          });
          return React.createElement(EventIconWrapper, {
            key: event.eventType + "_" + eventIdx
          }, React.createElement(TimeLine_1.Icon, {
            size: 15,
            title: "" + (eventDetail ? eventDetail.label + " - " : '') + Math.ceil(event.eventTime / 60) + "'",
            eventType: event.eventType,
            subType: event.type,
            theme: theme
          }));
        })));
      });
    };

    var renderCrewList_1 = function (crew) {
      var sportSectorCrew = sportCrew_1.find(function (i) {
        return i._id === match_1.rules.sport_sector;
      });

      if (Array.isArray(crew)) {
        return crew.map(function (crewMember, idx) {
          var crewItem = (sportSectorCrew ? sportSectorCrew.items : []).find(function (i) {
            return i._id === crewMember.position;
          });

          if (crewItem) {
            return React.createElement(ListRow, {
              key: crewMember.position + "_" + idx,
              lastIndex: crew.length === idx + 1
            }, React.createElement(ListCol, null, React.createElement("b", null, crewMember.sportnetUser.name)), React.createElement(ListCol, null, crewItem.label));
          }

          return null;
        });
      }

      return Object.keys(crew).map(function (key, idx) {
        var crewItem = (sportSectorCrew ? sportSectorCrew.items : []).find(function (i) {
          return i._id === key;
        });

        if (crewItem) {
          return React.createElement(ListRow, {
            key: key + "_" + idx,
            lastIndex: Object.keys(crew).length === idx + 1
          }, React.createElement(ListCol, null, React.createElement("b", null, crew[key].displayName)), React.createElement(ListCol, null, crewItem.label));
        }

        return null;
      });
    };

    var renderNomination = function (homeAway, team, nomination) {
      var athletes = nomination ? nomination.athletes || [] : [];
      var substitutes = athletes.filter(function (i) {
        return i.additionalData && i.additionalData.substitute;
      });
      return React.createElement(Segment_1["default"], {
        header: React.createElement(exports.StyledSegmentHeader, null, React.createElement(Header_1["default"], {
          size: "m"
        }, React.createElement(NominationHeader, null, team.organization.logo_public_url && React.createElement("img", {
          alt: "org_logo",
          src: team.organization.logo_public_url || ''
        }), team.displayName)))
      }, !!nomination ? React.createElement(NominationItems, null, !!athletes.length && React.createElement(Segment_1["default"], {
        noBottomGutter: true,
        header: React.createElement(exports.StyledSegmentHeader, null, React.createElement(Header_1["default"], {
          withSeparator: true,
          size: "s"
        }, homeAway === 'homeTeam' ? 'Domáci' : 'Hostia'))
      }, renderAthletesList_1(team.appSpace, nomination.athletes.filter(function (i) {
        return !i.additionalData || !i.additionalData.substitute;
      }))), !!substitutes.length && React.createElement(Segment_1["default"], {
        noBottomGutter: true,
        header: React.createElement(exports.StyledSegmentHeader, null, React.createElement(Header_1["default"], {
          withSeparator: true,
          size: "s"
        }, "N\u00E1hradn\u00EDci"))
      }, renderAthletesList_1(team.appSpace, substitutes)), (Array.isArray(nomination.crew) && nomination.crew.length || !!Object.keys(nomination.crew || {}).length) && React.createElement(Segment_1["default"], {
        noBottomGutter: true,
        header: React.createElement(exports.StyledSegmentHeader, null, React.createElement(Header_1["default"], {
          withSeparator: true,
          size: "s"
        }, "Realiza\u010Dn\u00FD t\u00EDm"))
      }, renderCrewList_1(nomination.crew))) : React.createElement(NotFound, null, React.createElement(Icon_1["default"], {
        name: "info",
        size: "l",
        color: theme.inactiveColor
      }), React.createElement("div", null, "Nomin\u00E1cia zatia\u013E nebola uzatvoren\u00E1")));
    };

    var homeTeam_1 = match_1.teams.find(function (i) {
      return sportnet_utilities_1.getProp(i, ['additionalProperties', 'homeaway'], '') === 'home';
    });
    var awayTeam_1 = match_1.teams.find(function (i) {
      return sportnet_utilities_1.getProp(i, ['additionalProperties', 'homeaway'], '') === 'away';
    });
    var homeTeamNomination = null;

    if (homeTeam_1 && match_1.nominations) {
      homeTeamNomination = match_1.nominations.find(function (i) {
        return i.teamId === homeTeam_1._id;
      });
    }

    var awayTeamNomination = null;

    if (awayTeam_1 && match_1.nominations) {
      awayTeamNomination = match_1.nominations.find(function (i) {
        return i.teamId === awayTeam_1._id;
      });
    }

    return React.createElement(React.Fragment, null, React.createElement(Segment_1["default"], null, React.createElement(Match_1["default"], {
      theme: theme,
      match: match_1,
      lastIndex: true,
      sportSectorsPhases: sportSectorPhases,
      fullWidth: true,
      settings: match_1.settings,
      verbose: true,
      onLiveScoreChange: function (_a) {
        var newTimer = _a.timer,
            newProtocol = _a.protocol;
        setTimer(newTimer);
        setProtocol(newProtocol);
      }
    })), (!!protocol && protocol.events && protocol.events.length > 0 || !!match_1.protocol && match_1.protocol.events && match_1.protocol.events.length > 0) && React.createElement(Segment_1["default"], {
      header: React.createElement(exports.StyledSegmentHeader, null, React.createElement(Header_1["default"], {
        withSeparator: true,
        size: "m"
      }, "Priebeh stretnutia"))
    }, React.createElement(TimeLine_1["default"], {
      teams: match_1.teams,
      protocol: protocol || match_1.protocol,
      timer: timer && !!Object.keys(timer).length ? timer : match_1.timer,
      settings: match_1.settings || {},
      eventTypes: sportSectorEvents_1 ? sportSectorEvents_1.items : [],
      phases: sportSectorsPhases ? sportSectorsPhases.items : []
    })), React.createElement(Grid_1.Row, null, !!homeTeam_1 && React.createElement(Grid_1["default"], {
      xs: 12,
      m: 6
    }, renderNomination('homeTeam', homeTeam_1, homeTeamNomination)), !!awayTeam_1 && React.createElement(Grid_1["default"], {
      xs: 12,
      m: 6
    }, renderNomination('awayTeam', awayTeam_1, awayTeamNomination))), React.createElement(Grid_1.Row, null, React.createElement(Grid_1["default"], {
      xs: 12,
      m: !!match_1.protocol && !!match_1.protocol.delegates ? 6 : 12
    }, React.createElement(Segment_1["default"], {
      header: React.createElement(exports.StyledSegmentHeader, null, React.createElement(Header_1["default"], {
        withSeparator: true,
        size: "m"
      }, "Miesto konania"))
    }, React.createElement(Grid_1.Row, null, React.createElement(Grid_1["default"], {
      xs: 12,
      s: 6
    }, React.createElement(FormGroup, null, React.createElement(Label_1["default"], null, "Majite\u013E"), React.createElement(Text, null, match_1.sportGround.owner))), React.createElement(Grid_1["default"], {
      xs: 12,
      s: 6
    }, React.createElement(FormGroup, null, React.createElement(Label_1["default"], null, "Adresa"), React.createElement(Text, null, match_1.sportGround.street + " " + match_1.sportGround.number + ", " + match_1.sportGround.city))), !!match_1.sportGround.additionalData && !!match_1.sportGround.additionalData.totalCapacity && React.createElement(Grid_1["default"], {
      xs: 12,
      s: 6
    }, React.createElement(FormGroup, null, React.createElement(Label_1["default"], null, "Celkov\u00E1 kapacita"), React.createElement(Text, null, match_1.sportGround.additionalData.totalCapacity))), !!match_1.sportGround.additionalData && !!match_1.sportGround.additionalData.seatingCapacity && React.createElement(Grid_1["default"], {
      xs: 12,
      s: 6
    }, React.createElement(FormGroup, null, React.createElement(Label_1["default"], null, "Miest na sedenie"), React.createElement(Text, null, match_1.sportGround.additionalData.seatingCapacity))), !!match_1.sportGround.additionalData && !!match_1.sportGround.additionalData.guestCapacity && React.createElement(Grid_1["default"], {
      xs: 12,
      s: 6
    }, React.createElement(FormGroup, null, React.createElement(Label_1["default"], null, "Kapacita sektora host\u00ED"), React.createElement(Text, null, match_1.sportGround.additionalData.guestCapacity))), !!match_1.sportGround.additionalData && !!match_1.sportGround.additionalData.vipSeatingCapacity && React.createElement(Grid_1["default"], {
      xs: 12,
      s: 6
    }, React.createElement(FormGroup, null, React.createElement(Label_1["default"], null, "Po\u010Det VIP sedadiel"), React.createElement(Text, null, match_1.sportGround.additionalData.vipSeatingCapacity)))))), !!match_1.protocol && !!match_1.protocol.delegates && React.createElement(Grid_1["default"], {
      xs: 12,
      m: 6
    }, React.createElement(Segment_1["default"], {
      header: React.createElement(exports.StyledSegmentHeader, null, React.createElement(Header_1["default"], {
        withSeparator: true,
        size: "m"
      }, "Zodpovedn\u00E9 osoby"))
    }, React.createElement(Grid_1.Row, null, match_1.protocol.delegates.map(function (delegate, idx) {
      var delegatesCodelist = sportSectorDelegates_1.find(function (i) {
        return i._id === match_1.rules.sport_sector;
      });
      var delegateCodelistItem = (delegatesCodelist || {
        items: []
      }).items.find(function (i) {
        return i._id === delegate.type;
      });

      if (delegateCodelistItem) {
        return React.createElement(Grid_1["default"], {
          key: "delegate_" + delegate.name + "_" + idx,
          xs: 12,
          s: 6
        }, React.createElement(FormGroup, null, React.createElement(Label_1["default"], null, delegateCodelistItem.label), React.createElement(Text, null, delegate.name)));
      }

      return null;
    }))))));
  }

  return null;
};

exports["default"] = styled_components_1.withTheme(WidgetMatchDetail);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;